/** How many ms to wait before action after successful callback is called */
export const TIMEOUT_AFTER_SUCCESSFUL_CALLBACK = 3000